import React from "react";
import { ReactComponent as FiltersIcon } from "../../Assets/Icons/filtersIcon.svg";
import { ReactComponent as DownArrow } from "../../Assets/Icons/greyDownArrow.svg";

const FilterButton = ({ onClick, isOpen }) => {
    // CSS filter to convert grey/black to #00ADEF (Swoodle Blue)
    const blueFilter =
        "invert(55%) sepia(68%) saturate(1759%) hue-rotate(167deg) brightness(93%) contrast(93%)";

    return (
        <button
            onClick={onClick}
            className={`group flex justify-center items-center gap-2 border rounded-md p-3 text-lg font-medium outline-none h-[40px] transition-all duration-300
        ${isOpen
                    ? "border-[#00ADEF] text-[#00ADEF]"
                    : "border-[#8C8C8C] text-[#8C8C8C] hover:border-[#00ADEF] hover:text-[#00ADEF]"
                }`}
        >
            <div className="flex items-center gap-2">
                <FiltersIcon
                    className="w-[20px] h-[20px] transition-all duration-300"
                    style={{
                        filter: isOpen ? blueFilter : "none",
                    }}
                />
                {/* Using styles to apply filter on hover for the group */}
                <style jsx>{`
          .group:hover svg {
            filter: ${blueFilter} !important;
          }
        `}</style>
                <span className="font-[500] text-[14px] font-poppins leading-[22px] text-inherit">
                    Filters
                </span>
            </div>
            <DownArrow
                className={`transition-all duration-300 transform ${isOpen ? "rotate-180" : "rotate-0"
                    }`}
                style={{
                    filter: isOpen ? blueFilter : "none",
                }}
            />
        </button>
    );
};

export default FilterButton;
